import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(undefined);


export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  const [role, setRole] = useState(sessionStorage.getItem('role'));

  useEffect(() => {
    if (token) {
  sessionStorage.setItem('token', token);
    } else {
  sessionStorage.removeItem('token');
    }
    if (role) {
  sessionStorage.setItem('role', role);
    } else {
  sessionStorage.removeItem('role');
    }
  }, [token, role]);

  const login = (newToken, newRole) => {
    // Persist synchronously so a caller that reloads the page immediately
    // (Login does) doesn't beat the effect below and lose the session.
    if (newToken) sessionStorage.setItem('token', newToken);
    if (newRole) sessionStorage.setItem('role', newRole);
    setToken(newToken);
    setRole(newRole);
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('role');
    setToken(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ token, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
